import { GuestUserKey } from "./DomainTyped/GuestUserKey";
export class DomainApi {
    constructor(restClient) {
        this.restClient = restClient;
    }
    async domainCheck(data) {
        const res = await this.restClient.post("/api/users/me/domains", data);
        return res.validate();
    }
    async guestUserKey(id) {
        const res = await this.restClient.get(`/api/studios/${id}`);
        return res.toModelFromType(GuestUserKey);
    }
}
